import { useQuery, useMutation, useQueryClient } from 'react-query'
import {
  createUser,
  deleteUser,
  getAllUsers,
  updateUser
} from '../api-services/users'

const usersKey = 'users'

const useGetAllUsers = params => {
  const response = useQuery({
    queryKey: [usersKey, params],
    queryFn: () => getAllUsers(params),
    keepPreviousData: true
  })

  return response
}

const useCreateUser = mutationOptions => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: payload => createUser(payload),
    onSuccess: data => {
      queryClient.invalidateQueries([usersKey])

      if (mutationOptions.onSuccess) {
        mutationOptions.onSuccess(data)
      }
    },
    onError: error => {
      if (mutationOptions.onError) {
        mutationOptions.onError(error)
      }
    }
  })

  return {
    createUser: mutation.mutate,
    isLoading: mutation.isPending,
    ...mutation
  }
}

const useEditUser = mutationOptions => {
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationFn: ({ id, ...payload }) => updateUser(id, payload),
    onSuccess: data => {
      queryClient.invalidateQueries([usersKey])

      if (mutationOptions.onSuccess) {
        mutationOptions.onSuccess(data)
      }
    },
    onError: error => {
      if (mutationOptions.onError) {
        mutationOptions.onError(error)
      }
    }
  })

  return {
    editUser: mutation.mutate,
    isLoading: mutation.isPending,
    ...mutation
  }
}

const useDeleteUser = mutationOptions => {
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationFn: id => deleteUser(id),
    onSuccess: data => {
      queryClient.invalidateQueries([usersKey])
      mutationOptions?.onSuccess?.(data)
    },
    onError: error => {
      mutationOptions?.onError?.(error)
    }
  })

  return {
    deleteUser: mutation.mutate,
    isLoading: mutation.isPending,
    ...mutation
  }
}

export { useGetAllUsers, useCreateUser, useEditUser, useDeleteUser }
